// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered-image {
  display: block;
  margin: 0 auto;
}

.img-light {
  display: block;
  margin: 0 auto;
  width: 80px;
  z-index: 999;
  position: relative;
  top: -147px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/circular-slider/circular-slider.component.scss","webpack://./src/components/general%20components/circular-slider/circular-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;ACCF;;ADEA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ACCF","sourcesContent":[".centered-image {\n  display: block;\n  margin: 0 auto;\n}\n\n.img-light {\n  display: block;\n  margin: 0 auto;\n  width: 80px;\n  z-index: 999;\n  position: relative;\n  top: -147px;\n}\n",".centered-image {\n  display: block;\n  margin: 0 auto;\n}\n\n.img-light {\n  display: block;\n  margin: 0 auto;\n  width: 80px;\n  z-index: 999;\n  position: relative;\n  top: -147px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
